import {GameColor} from '../../../../shared/scripts/GameColor'
import {GameFont} from '../../../../shared/scripts/GameFont'
import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationKnightView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationKnightView'
import {Sprites} from '../../../../shared/scripts/ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../../../shared/scripts/UIGameSpriteHandler'
import {UIPlayerAdditionalInformationLayer} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'

export class UIMGamePlayerInformationKnightView extends UIGamePlayerInformationKnightView {
    protected createMyKnightStateView() {
        this.createKnightView()
    }

    protected createOpponentKnightView() {
        this.createKnightView()
    }

    private createKnightView() {
        const container = this.playerInformation.getContainerForAdditionalPlayerInformation(UIPlayerAdditionalInformationLayer.Layer0)
        const w = container.width
        const h = container.height

        const iconX = w * 0.1
        const iconY = h * 0.5
        const iconW = h * 0.4
        const iconH = iconW

        const countX = iconX + iconW * 0.5
        const countY = iconY * 1
        const countH = iconH
        const countW = countH * 2

        const iconPadding = 0
        const fontSize = iconH * 0.9

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_swords)
        this.knightStrengthView = new ItemCountView(iconX, iconY, iconW, iconH, container, texture,
            countX, countY, countW, countH, iconPadding, GameFont.Size.XL, GameColor.getColor(GameColor.Color.White))
        this.knightStrengthView.count.changeStyle({fontSize: fontSize})
    }
}
